import groupBy from 'lodash/groupBy'

import React, { useState } from 'react'
import { useSelector } from 'hooks/use-redux'
import type { NativeTag, NativeTagWithCategory } from 'types/track'
import { getNativeTags } from '@disco/state-management/selectors/tags'
import type { ColorIndicator } from '@disco/utils/color-indicators'
import ColorIndicatorSelect from 'components/common/color-indicator-select'
import Row from 'components/common/row'
import DialogFooter from 'components/modals/dialog-footer'
import Button from 'components/ui/button'
import Heading from 'components/ui/heading'
import ModalWindow from 'components/ui/modal-window'
import Tag from 'components/ui/tag'
import { PlaylistTag } from 'types/playlist'
type Props = {
  tag: NativeTagWithCategory
  onClose: () => void
  onSubmit: (color: ColorIndicator | null | undefined) => unknown
}

const TrackTagColorIndicatorModal = (props: Props): React.ReactNode => {
  const nativeTags: NativeTagWithCategory[] = useSelector(getNativeTags)
  const [selectedColor, setSelectedColor] = useState<
    ColorIndicator | null | undefined
  >(props.tag.color)

  const handleSubmit = () => {
    props.onSubmit(selectedColor)
  }

  return (
    <ModalWindow
      header={<Heading>Add color indicator to</Heading>}
      actions={
        <DialogFooter
          onClose={props.onClose}
          primary={
            <Button
              appearance="primary"
              caption="Add indicator"
              onClick={handleSubmit}
            />
          }
        />
      }
      onClose={props.onClose}
      isOpen
      width="small"
    >
      <Row columnsSize={[12]}>
        <div>
          <Tag tag={props.tag.name} tagColor={selectedColor} />
        </div>
      </Row>
      <Row columnsSize={[12]}>
        <div>
          <ColorIndicatorSelect
            tooltip="Colored indicators appear as colored dots on the track in the explorer."
            used={groupBy(
              nativeTags.filter(tag => tag.color),
              'color',
            )}
            value={selectedColor}
            onChange={setSelectedColor}
          />
        </div>
      </Row>
    </ModalWindow>
  )
}

export default TrackTagColorIndicatorModal
